// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon__ceR3r"};